<div class="row">
  <div class="col-md-3">
    <dl>
      <dt>Business Name:</dt>
      <dd>{{profile.businessName}}</dd>
      <dt>Dealer ID:</dt>
      <dd>{{profile.id}}</dd>
      <dt>Expiration Date:</dt>
      <dd>{{(profile.expirationDate | date:'longDate') || '--'}}</dd>
      <dt>Business Contact Name:</dt>
      <dd *ngIf="profile.contactName; else emptyDD">{{profile.contactName | name}}</dd>
      <ng-container *appHasAuthority="'MY_INFO'">
        <dt>License Status:</dt>
        <dd>{{DealerLicenseStatus.meaning(profile.status) || '--'}}</dd>
      </ng-container>
      <dt>Market Type:</dt>
      <dd>
        <span *ngIf="0 == profile.marketTypes.size; else marketTypes">--</span>
      </dd>
    </dl>
  </div>
  <div class="col-md-3">
    <dl>
      <dt>Business Address</dt>
      <dd *ngIf="profile.businessAddress; else emptyDD">{{profile.businessAddress.street}}<br>{{profile.businessAddress.getCityStateZip()}}</dd>
      <dt>Mailing Address</dt>
      <dd *ngIf="profile.mailingAddress; else emptyDD">{{profile.mailingAddress.street}}<br>{{profile.mailingAddress.getCityStateZip()}}</dd>
      <ng-container  *appHasAuthority="'MY_INFO'">
        <dt>Market Contact Name</dt>
        <dd *ngIf="profile.marketContactName; else emptyDD">{{profile.marketContactName | name}}</dd>
      </ng-container>
    </dl>
  </div>
  <div class="col-md-3">
    <dl>
      <dt>Business Phone</dt>
      <dd>{{profile.businessPhone || '--'}}</dd>
      <dt>Fax</dt>
      <dd>{{profile.faxNumber || '--'}}</dd>
      <dt>Business E-mail</dt>
      <dd>{{profile.businessEmail || '--'}}</dd>
      <ng-container  *appHasAuthority="'MY_INFO'">
        <dt>Market Contact Phone</dt>
        <dd>{{profile.marketPhone || '--'}}</dd>
      </ng-container>
    </dl>
  </div>
</div>

<ng-template #emptyDD><dd>--</dd></ng-template>

<ng-template #marketTypes>
  <span *ngFor="let marketType of profile.marketTypes; last as isLast">
    <ng-container [ngSwitch]="marketType">
      <strong *ngSwitchCase="MarketType.AQ">AQ</strong>
      <strong *ngSwitchCase="MarketType.NAQ">Non-AQ</strong>
    </ng-container>
    <ng-container *ngIf="!isLast">, </ng-container>
  </span>
</ng-template>
